import React, {useEffect} from "react"
import SendRequestForm from "../forms/SendRequestForm";
import {
    Box,
    CssBaseline, Grid, Typography
} from "@mui/material";
import Footer from "../components/Footer";
import CustomNavbar from "../components/CustomNavbar";
import LeftNavigation from "../components/LeftNavigation";
import RightLogo from "../components/RightLogo";
import Subtitle from "../components/Subtitle";
import {sendEventsData} from "../store/actions/actions";
import {useAppDispatch} from "../store/store";
import {useTranslation} from "react-i18next";

const SimulationPage = ()=>{
    localStorage.removeItem("tum_leitfaden_input")
    localStorage.removeItem("tum_leitfaden_result")
    const dispatch = useAppDispatch();
    const {t} = useTranslation()
    useEffect(() => {
        dispatch(sendEventsData({
            date: new Date().toLocaleString(),
            timestamp: new Date().getTime(),
            value:"/simulation",
            type:"pageView"
        }))
    });
    return(
        <React.Fragment>
            <CssBaseline />
            <CustomNavbar />
                <Grid container style={{marginTop: 8}} spacing={3}>
                    <Grid item xs={5} md={2} xl={2}>
                        <LeftNavigation />
                    </Grid>
                    <Grid item xs={6} md={8} xl={8}>
                        <Box sx={{marginBottom: 8}}>
                            <Subtitle/>
                        </Box>
                        <Typography paragraph>
                            {t('simulation_page.subtitle' as any)}
                        </Typography>
                        <SendRequestForm/>
                    </Grid>
                    <Grid item xs={1} md={2} xl={2}>
                      <RightLogo/>
                    </Grid>
                </Grid>
            <Footer/>
        </React.Fragment>
    )
}
export default SimulationPage
